import { AxiosResponse } from 'axios';

import {
    API_CASINO_SETTINGS_GAMES_SEO,
    API_CASINO_SETTINGS_GAMES_SEO_ASSIGN_TEMPLATES,
    API_CASINO_SETTINGS_GAMES_SEO_CREATE,
    API_CASINO_SETTINGS_GAMES_SEO_GET_TITLES_BY_GAME_CREATOR_ID,
    API_CASINO_SETTINGS_GAMES_SEO_SHOW,
    API_CASINO_SETTINGS_GAMES_SEO_UPDATE,
} from '../../../../crm/casino/pages/Helpers/CrmApiUrls';
import AbstractCasinoCRMApi from '../../AbstractCasinoCRMApi';
import { CreateGameCreatorSeoRequest } from '../Requests/CreateGameCreatorSeoRequest';
import { UpdateGameCreatorSeoRequest } from '../Requests/UpdateGameCreatorSeoRequest';
import GetAllCasinoGameSeoTagsResponse from '../Responses/CasinoGameSeoTagResponse';

import CasinoGameSeoTag from 'casino/Api/Models/CasinoGameSeoTag';
import { replaceUrlParams } from 'crm/casino/pages/Helpers/UrlHelper';

class SeoSettingsApi extends AbstractCasinoCRMApi {
    public async getAll(gameCreatorId: number): Promise<GetAllCasinoGameSeoTagsResponse> {
        return (await this.get(`${API_CASINO_SETTINGS_GAMES_SEO}/${gameCreatorId}`)).data;
    }

    public async show(id: number): Promise<GetAllCasinoGameSeoTagsResponse> {
        return (await this.get(replaceUrlParams(API_CASINO_SETTINGS_GAMES_SEO_SHOW, { id }))).data;
    }

    public update(data: UpdateGameCreatorSeoRequest): Promise<AxiosResponse> {
        return this.post(API_CASINO_SETTINGS_GAMES_SEO_UPDATE, data);
    }

    public create(data: CreateGameCreatorSeoRequest): Promise<AxiosResponse> {
        return this.post(API_CASINO_SETTINGS_GAMES_SEO_CREATE, data);
    }

    public assignTemplatesToGames(gameCreatorId: number): Promise<AxiosResponse> {
        return this.post(replaceUrlParams(API_CASINO_SETTINGS_GAMES_SEO_ASSIGN_TEMPLATES, { gameCreatorId }));
    }

    public async getTitlesByCreatorId(gameCreatorId: number): Promise<CasinoGameSeoTag[]> {
        return (
            await this.get(
                replaceUrlParams(API_CASINO_SETTINGS_GAMES_SEO_GET_TITLES_BY_GAME_CREATOR_ID, { gameCreatorId })
            )
        ).data;
    }
}

export default new SeoSettingsApi();
